import $ from "jquery";

// MANUAL SPIN
export class ManualSpinCustomization {
    constructor() {

        // Manual spin instant update (checkbox)
        $('[name="variant[enable_manual_spin]"]').change(function () {
            if (this.checked || this.value === "true") {
                viewer().manual_spin(true)
                $('[name="variant[loops]"]').trigger('change')
            } else {
                viewer().manual_spin(false)
            }
        })

        // Spin direction instant update
        $('[name="variant[reverse_spin]"]').change(function () {
            viewer().reverse_spin(this.value === "true")
        })

        // Rotation axis instant update
        $('[name="variant[tilt_rotation_axis]"]').change(function () {
            viewer().tilt_rotation_axis(this.value === "true")
        })

        // Loops (sensitivity) instant update
        const loops = $('[name="variant[loops]"]')
        const loopsSlider = $('#loops_slider')

        loops.on('input', function () {
            viewer().manual_spin_sensitivity(parseFloat(this.value))
            loopsSlider.val(this.value)
        })

        loopsSlider.on('input', function () {
            loops.val(this.value)
            viewer().manual_spin_sensitivity(parseFloat(this.value))
        })

        // Settle speed instant update
        $('[name="variant[settle_speed]"]').change(function () {
            viewer().manual_spin_settle_speed(parseInt(this.value))
        })

        // Drag instant update
        $('[name="variant[drag]"]').change(function () {
            viewer().manual_spin_interaction(this.value === "true" ? "drag" : "hover")
        })


        // INERTIA
        const inertia = $('[name="variant[inertia]"]')
        const inertiaSlider = $('#inertia_slider')

        // Inertia instant update
        inertia.on('input', function () {
            const labels = ["0", "1", "2", "3", "4", "5", "∞"]
            const values = [0, 1, 2, 3, 4, 5, -1]
            viewer().manual_spin_inertia(values[labels.indexOf(this.value)])
            inertiaSlider.val(labels.indexOf(this.value))

            if ($(this).val() === "∞") {
                $('#settle_speed_container').slideDown()
            } else {
                $('#settle_speed_container').slideUp()
            }
        })

        inertiaSlider.on('input', function () {
            const labels = ["0", "1", "2", "3", "4", "5", "∞"]
            const values = [0, 1, 2, 3, 4, 5, -1]
            inertia.val(labels[this.value])
            viewer().manual_spin_inertia(values[this.value])

            if (labels[this.value] === "∞") {
                $('#settle_speed_container').slideDown()
            } else {
                $('#settle_speed_container').slideUp()
            }
        })

        // Infinite value mapping on load and submit

        if (inertia.val() === "-1") {
            // Map stored -1 value to the "∞" label and max slider position
            inertia.val("∞")
            inertiaSlider.val(6)
        }

        // Normalize infinite value before submit
        $('#customize_variant, #customize_variant_spin, #customize_variant_behavior').on('submit', function () {
            if (inertia.val() === "∞") {
                inertia.val(-1)
            }
        })
    }
}